import { HTMLAttributes, Key } from 'react'

export const DATA_GRID_PAGE_SIZE = 50
export const DATA_GRID_OVER_SCAN = 50
export const DATA_GRID_LIST_OVER_SCAN = 10
export const DATA_GRID_VERTICAL_OFFSET = 0
export const DATA_GRID_HORIZONTAL_OFFSET = 0
export const LOCAL_STORAGE_KEY_CHARTS_TOGGLE_STATUS = 'charts-toggle-status'
export const LOCAL_STORAGE_KEY_MAP_TOGGLE_STATUS = 'map-toggle-status'
export const LOCAL_STORAGE_KEY_AGGREGATION_MODE = 'aggregation-mode'

export type FilterAggregationFieldSettings = { type: string; size: number }
export type ChartAggregationFieldSettings = {
  type: string
  field: string
  size?: number
}

export type AggregationMode = keyof typeof AggregationModeLabels
export enum AggregationModeLabels {
  gws = 'GWs',
  mws = 'MWs',
  count = 'Count',
}

export enum AggregationModeUnits {
  gws = 'GWs',
  mws = 'MWs',
}

export type AggregationModeOption = keyof typeof AggregationModeOptions
export enum AggregationModeOptions {
  watts = 'Capacity',
  count = 'Count',
}

export type AggregationField = {
  primary: string
  primaryLabel: string
  secondary: string
  secondaryLabel: string
  isChart: boolean
  chartConfig?: {
    supportsClicks: boolean
    enableTotals?: boolean
    aggregationModeOptions?: Array<AggregationModeOption>
  }
  isGridFilter: boolean
  filterConfig?: {
    filterId?: string
    dataField?: 'key' | 'id'
    settings?: FilterAggregationFieldSettings
  }
  regions: RegionMode[]
}

export type FilterAggregationField = {
  primary: string
  settings?: FilterAggregationFieldSettings
}

export type ChartAggregationField = {
  primary: string
  secondary: string
  settings?: ChartAggregationFieldSettings
}

interface AggregationHistoryEntry {
  key: string
  [additionalKey: string]: number | string
}

type PrimaryKeys = AggregationField[][number]['primary']

export type AggregationHistory = {
  [K in PrimaryKeys]?: AggregationHistoryEntry[]
}

export enum ChartsDisplayStatus {
  COLLAPSED = 'charts-collapsed',
  EXPANDED = 'charts-expanded',
}

export enum ChartsMapDisplayStatus {
  MAP_DISPLAYED = 'map-displayed',
  CHART_DISPLAYED = 'chart-displayed',
}

export enum ClaimsToggle {
  UT = 'UT',
  DG = 'DG',
  EUR = 'EUR',
}

export enum RegionMode {
  US = 'usRegion',
  EUR = 'eurRegion',
  MULTI = 'multiRegion',
}

export type MuiListItemWithKey = HTMLAttributes<HTMLLIElement> & {
  key: Key
}

export const SIGNAL_ORGANIZATION_ROLE_LABELS = {
  puc: 'PUC',
  developer: 'Developer',
  offtaker: 'Offtaker',
  utility: 'Utility',
  advisor: 'Advisor',
  epc: 'EPC / Contractor',
  'iso|rto': 'ISO | RTO',
}

export const QUEUE_ORGANIZATION_ROLE_LABELS = {
  developer: 'Developer',
  networkOperator: 'Network Operator',
  planningAuthority: 'Planning Authority',
  utility: 'Utility',
  isoRtoConnection: 'ISO | RTO Market',
}
